import { render } from "./LiverFunctionBkp.vue?vue&type=template&id=4b79108c"
import script from "./LiverFunctionBkp.vue?vue&type=script&lang=js"
export * from "./LiverFunctionBkp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__